import { PATH, PROP_PATH_SEP } from './constants.js'; // Joins an array that potentially contains symbols, which need an explicit
// 'toString()'

var join = function join(arr, joiner) {
  return arr.map(function (item) {
    return item.toString();
  }).join(joiner);
};
/**
 * Convert a target and a prop into a user-friendly string like store.tasks.1.done
 */


var makeUserString = function makeUserString(propPath) {
  return join(propPath, '.');
};

var makeInternalString = function makeInternalString(propPath) {
  return join(propPath, PROP_PATH_SEP);
};
/**
 * Takes the path stored in an object, and a new prop, and returns the two
 * combined
 */


var extend = function extend(target, prop) {
  var basePath = target[PATH] || [];
  if (typeof prop === 'undefined') return basePath;
  return basePath.concat(prop);
};
/**
 * Convert a target and a prop into a user-friendly string like store.tasks.1.done
 */


var extendToUserString = function extendToUserString(target, prop) {
  return makeUserString(extend(target, prop));
};

var addProp = function addProp(target, propPath) {
  if (!target) return;
  Object.defineProperty(target, PATH, {
    value: propPath,
    writable: true
  });
};

var get = function get(target) {
  return target[PATH] || [];
};

export { addProp, extend, extendToUserString, get, makeInternalString, makeUserString };